import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import AdminNavbar from "../Components/AdminNavbar";

export default function AllBlog() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const res = await axios.get("https://dropshopi.com/api/get-blogs.php");
      if (res.data.status === "success") {
        setBlogs(res.data.data || []);
      } else {
        console.error("Failed to fetch blogs:", res.data.message);
        setBlogs([]);
      }
    } catch (err) {
      console.error("Error fetching blogs", err);
      setBlogs([]);
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This blog will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (confirm.isConfirmed) {
      try {
        const res = await axios.post("https://dropshopi.com/api/delete-blog.php", { id });

        if (res.data.status === "success") {
          Swal.fire("Deleted!", res.data.message, "success");
          fetchBlogs();
        } else {
          Swal.fire("Error", res.data.message || "Failed to delete blog.", "error");
        }
      } catch (error) {
        console.error(error);
        Swal.fire("Error", "Something went wrong!", "error");
      }
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="container py-5 text-white"
      style={{ background: "#121212", minHeight: "100vh" }}
    >


        <AdminNavbar/>
      <h2 className="mb-4 text-warning">All Blogs</h2>

      {loading ? (
        <p>Loading blogs...</p>
      ) : blogs.length === 0 ? (
        <p>No blogs found.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-dark table-striped table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Image</th>
                <th>Title</th>
                <th>Slug</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {blogs.map((blog, index) => (
                <tr key={blog.id}>
                  <td>{index + 1}</td>
                  <td>
                    {blog.featured_image ? (
                      <img
                        src={blog.featured_image}
                        alt={blog.alt_text || "Blog Image"}
                        style={{ width: 80, height: 50, objectFit: "cover" }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td>{blog.title}</td>
                  <td>{blog.slug}</td>
                  <td>{new Date(blog.created_at).toLocaleDateString()}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => navigate(`/edit-blog/${blog.slug}`)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(blog.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </motion.div>
  );
}
